export interface ILanguage {
    iso: string;
    isoFlag?: string;
    desc: string;
    descLocale?: string;
    meetingAcceptance?: boolean;
    chat?: boolean;
}

export const Languages: ILanguage[] = [
    { iso: 'en', desc: 'English', meetingAcceptance: true, chat: true },
    { iso: 'fr', desc: 'French', meetingAcceptance: true, chat: true, descLocale: 'Français' },
    { iso: 'es', desc: 'Spanish', meetingAcceptance: true, chat: true, descLocale: 'Español' },
    { iso: 'it', desc: 'Italian', meetingAcceptance: false, chat: true, descLocale: 'Italiano' },
    { iso: 'ja', desc: 'Japanese', meetingAcceptance: false, chat: true, isoFlag: 'jp', descLocale: '日本語' },
    { iso: 'pt', desc: 'Portuguese', meetingAcceptance: true, chat: true, descLocale: 'Português' },
    { iso: 'de', desc: 'German', meetingAcceptance: true, chat: false, descLocale: 'Deutsch' },
    { iso: 'sv', desc: 'Swedish', meetingAcceptance: true, chat: false, isoFlag: 'se', descLocale: 'Svenska' }
];

export type SupportedLanguagesType = typeof Languages[number]['iso'];
